const depthAccent = (level) => `var(--sb-org-depth-${Math.max(0, level) % 5})`

export default function OrganizationTreeGuides({ level, guides, indentStep = 18 }) {
  return (
    <>
      {guides.continuingLevels.map((guideLevel) => (
        <span className="org-tree-continuation" style={{ '--org-guide-indent': typeof indentStep === 'number' ? `${guideLevel * indentStep}px` : `calc(${guideLevel} * ${indentStep})`, '--org-tree-line-accent': depthAccent(guideLevel - 1) }} key={guideLevel} aria-hidden="true" />
      ))}
      {guides.hasParent && <span className={`org-tree-branch${guides.isLastChild ? ' is-last-child' : ''}`} style={{ '--org-tree-line-accent': depthAccent(level - 1) }} aria-hidden="true" />}
      {guides.hasChildren && <span className="org-tree-child-stem" style={{ '--org-tree-line-accent': depthAccent(level) }} aria-hidden="true" />}
    </>
  )
}
